import { filter, split, reduce, find, sortBy, findIndex  } from 'lodash';
import { IFarm, IProduct, ISilo, IPedido, IFeedPlan, IFeed, IFestivo, IIPedido, IIFeedPlan, IIFarm } from './types';
import { adalApiFetch } from './adalConfig';

const fetchAPI = (
    url: string,
    method: string,
    parseJSON = false,
    body: any = undefined,
    headers = true
): Promise<any> => {
    return adalApiFetch(fetch, url, {
        method: method,
        mode: 'cors',
        redirect: 'follow',
        body: body ? JSON.stringify(body) : body,
        headers: headers
            ? new Headers({
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json; charset=utf-8',
            })
            : undefined
    }).then((response: any) => {
        if (response.ok) {
            if (parseJSON) {
                return response.json();
            }
        } else if (!parseJSON) {
            throw new Error(`Error ${response.status}`);
        } else {
            try {
                return response.json().then((data: any) => {
                    console.log('Error!');
                    return Promise.reject(new Error(data.message));
                });
            } catch (err) {
                throw new Error(`Error ${response.status}`);
            }
        }
        return response;
    });
}

const searchFarms = (inputData:Array<IIFarm>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Farms : Array<IIFarm> = inputData;

    arrayValues.forEach(element => {
        Farms = filter(Farms,function(item){
        return item['name'].toLowerCase().indexOf(element)!==-1 || String(item['id']).toLowerCase().indexOf(element)!==-1;
        });
    });

    return Farms;
}

const searchProducts = (inputData:Array<IProduct>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Products : Array<IProduct> = inputData;

    arrayValues.forEach(element => {
        Products = filter(Products,function(item){
        return item['itemName'].toLowerCase().indexOf(element)!==-1||
        String(item['typeDsc']).toLowerCase().indexOf(element)!==-1;
        });
    });
    return Products;
}

const searchPedidos = (inputData:Array<IIPedido>, value: string) => {
    let lowerCaseValue = value.toLowerCase();
    let arrayValues : Array<string> = splitData(lowerCaseValue);
    let Pedidos : Array<IIPedido> = inputData;
    arrayValues.forEach(element => {
        Pedidos = filter(Pedidos,function(item){
            return item['farm']['name'].toLowerCase().indexOf(element)!==-1 || 
                item['idPedido'].toLowerCase().indexOf(element)!==-1 
                //|| getStatusDescriptionColor(item['status'])[0].toLowerCase().indexOf(element)!==-1;
                || item['statusDsc'].toLowerCase().indexOf(element)!==-1;
        });
    });

    return Pedidos;
}

const splitData = (input:string) => {
    return split(input,' ');
}

const GetFormattedDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return year + "-" + (month < 10?'0'+month:month) + "-" + (day < 10?'0'+day:day)+"T00:00:00.000Z";
}

const GetDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return year + "-" + (month < 10?'0'+month:month) + "-" + (day < 10?'0'+day:day);
}

const getNextOrden = (input:Array<ISilo>)=>{
    let orderedInput = sortBy(input, [function(o) { return o.order; }]);
    for (let i = 0; i < orderedInput.length; i++) {
       
        if (orderedInput[i].order !== (i + 1)) 
          return (i+1);
    }
    return orderedInput.length + 1; 
}

const getQuantitySilo = (capacidadSilo:number, quantity: number, cantidadAcum:number) => {
    if(!(cantidadAcum < quantity))
        return 0;
    
    let result = capacidadSilo - (quantity-cantidadAcum);
    if(result < 0){
        return capacidadSilo
    }
    return (quantity-cantidadAcum);
}

const getAcumuladoPienso = (input:Array<ISilo>) => {
    let cantidadAcum = reduce(
        input,
        function(accumulated, e){
            return accumulated + (e.quantity!==undefined?e.quantity:0);
        },
        0
    );

    return cantidadAcum;
}

// Algorisme pactat amb client (SQ01-678): suma dies CALENDARI amb regles per dia de la setmana, NO dies laborables.
// Doc referència: SQ01-678_festivos_documentacion_tecnica.md — NO canviar l'enfocament sense revisar-lo.
const verifyDateTimeLimit=(inputData:any, maxHour: number, beforeLimitTime:number, festivos: Array<IFestivo>)=>{

    const isFestivo = (inputDay: Date) => { // No deja poner ni Sábado ni Domingo ni los días específicos como festivos
        if(inputDay.getDay() !== 0 && inputDay.getDay() !== 6 && findIndex(festivos, function(o){return new Date(o.date).toDateString() === inputDay.toDateString()}) == -1){
            return false;
        } else {
            return true;
        }
    }

    const verifyHour = (maxHour: number, currentDate: Date) => { // Verifica que no supere la hora máxima de pedido del día
        if((currentDate.getHours()*3600+(currentDate.getMinutes()*60)) < maxHour || maxHour === 0){
            return true;
        } else {
            return false;
        }
    }

    let currentDatetime:Date = new Date();
    let selectedDate:Date = new Date(inputData);

    let effectiveDay:Date = new Date(currentDatetime);
    let advancedFromHoliday = false;

    if(isFestivo(effectiveDay)){
        while(isFestivo(effectiveDay)){
            effectiveDay.setDate(effectiveDay.getDate() + 1);
        }
        advancedFromHoliday = true;
    }

    let daysToAdd = beforeLimitTime;
    if(!advancedFromHoliday && !verifyHour(maxHour, currentDatetime)){
        daysToAdd = beforeLimitTime + 1;
    }
    if(effectiveDay.getDay() === 5){
        daysToAdd += 2;
    }

    let minDate:Date = new Date(effectiveDay);
    minDate.setHours(0,0,0,0);
    minDate.setDate(minDate.getDate() + daysToAdd);
    while(isFestivo(minDate)){
        minDate.setDate(minDate.getDate() + 1);
    }

    // Usar la fecha más tardía entre la seleccionada y la mínima
    if(selectedDate.getTime() < minDate.getTime()){
        selectedDate = minDate;
    }

    // Asegurar que la fecha seleccionada sea hábil
    while(isFestivo(selectedDate)){
        selectedDate.setDate(selectedDate.getDate() + 1);
    }

    let wasChanged = new Date(inputData).toDateString() !== selectedDate.toDateString();

    return [selectedDate, wasChanged];
}

const createArrayPedido = (farm:IFarm, cart: Array<IProduct> ,cartDate: any, 
    cartComments: string|undefined,
    idPedido:number|undefined, estado: number, moveType: number) => {
    let currentPedido : IPedido =  {
    business: farm.business,
    id: idPedido,
    farmId: farm.id,
    date: GetFormattedDate(cartDate), 
    comments: cartComments!==undefined?cartComments:'', 
    status: estado, 
    products:cart,
    farm: farm,
    numberLines: cart.length,
    moveType: moveType
    }

return currentPedido
}

const calculateQuantityItems = (inputCartProducts : Array<IProduct>) => {
    return find(inputCartProducts, function(o) {return o.quantity==undefined||o.quantity==0})
}

const GetFormattedPedidoDate = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime .getFullYear();
    return (day < 10?'0'+day:day) + "/" + (month < 10?'0'+month:month) + "/" + year;
}

const GetDatetimeFormat = (inputData: any) => {
    var todayTime = new Date(inputData);
    var month = todayTime.getMonth() + 1;
    var day = todayTime.getDate();
    var year = todayTime.getFullYear();
    var hour = todayTime.getHours();
    var minut = todayTime.getMinutes();

    return (day < 10?'0'+day:day) + "/" + (month < 10?'0'+month:month) + "/" + year + " " + (hour < 10?'0'+hour:hour)+ ":" + (minut < 10?'0'+minut:minut)+"h";
}

function addZeroesDecimals(num:number, decimals:number) {
    let roundDecimals:string = num.toFixed(decimals);
    roundDecimals = roundDecimals.replace('.',',');
    return roundDecimals;
}

function addThousandSeparator(num:string|number, comma:boolean) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `${comma?',':'.'}`);
}

const allowAddItem=(product:IProduct, farm:IFarm, currentFeedStageIndex:number, feedPlan: IFeedPlan)=>{
    let result = undefined; // Por defecto permite pedirlo

    if(!feedPlan.continues && currentFeedStageIndex !== 99){ // Realiza el control en caso de no ser una granja de Ciclo contínuo y permite siempre coger los productos de la etapa 99

        // Primero verifica si se ha sobrepasado la desviación máxima permitida
        const stage = feedPlan.plan[currentFeedStageIndex];
        const hasFeed = stage !== undefined && Array.isArray(stage.feed) && stage.feed.length > 0;
        if(hasFeed){
            let qtyReserved = stage.feed[0].qtyReserved;
            let qtyReal = stage.feed[0].qtyReal;
            let qtyRegularization = stage.feed[0].qtyRegularization || 0;
            let qtyPrevista = stage.feed[0].qtyEstimated;
            let qtyPercentage = ((qtyReal + qtyReserved - qtyRegularization)/qtyPrevista)*100;

            let upDesv = stage.feed[0].upperAllowedDeviation + 100;

            if(qtyPercentage >= upDesv){
                result = `LÍMITE ALCANZADO`;
            }
        }

    }
    
    if(product.medicated == 1){ // Se comprueba que si el producto es medicado, el usuario pueda pedirlo para esa granja
        if(farm.allowMedicado == 0){
            result = `NO AUTORIZADO`;
        }
    }

    return result;
}

const OUT_OF_SEQUENCE_GAP = 10;

const getAuxiliaryStageIndices = (plan: Array<IIFeedPlan>): Set<number> => {
    const indices = new Set<number>();
    let lastSequentialStage = -1;

    for (let i = 0; i < plan.length; i++) {
        if (plan[i].feedStage === 99) continue;

        if (lastSequentialStage === -1) {
            lastSequentialStage = plan[i].feedStage;
            continue;
        }

        if (plan[i].feedStage - lastSequentialStage > OUT_OF_SEQUENCE_GAP) {
            indices.add(i);
        } else {
            lastSequentialStage = plan[i].feedStage;
        }
    }

    return indices;
};

const getNextSequentialStageIndex = (currentIndex: number, plan: Array<IIFeedPlan>, auxiliaryIndices: Set<number>): number => {
    for (let i = currentIndex + 1; i < plan.length; i++) {
        if (!auxiliaryIndices.has(i) && plan[i].feedStage !== 99) return i;
    }
    return -1;
};

const getPrevSequentialStageIndex = (currentIndex: number, plan: Array<IIFeedPlan>, auxiliaryIndices: Set<number>): number => {
    for (let i = currentIndex - 1; i >= 0; i--) {
        if (!auxiliaryIndices.has(i) && plan[i].feedStage !== 99) return i;
    }
    return -1;
};

const getProductsCurrentFeedPlanStage=(products:Array<IProduct>, farm:IFarm)=>{
    let newProducts:Array<IProduct> = [];

    farm.feedPlan.map((feedPlan:IFeedPlan, idx00:number)=>{
        const auxiliaryIndices = getAuxiliaryStageIndices(feedPlan.plan);
        let currentFeedStageIndex = getCurrentFeedPlanStage(feedPlan, auxiliaryIndices);
        let etapa99Index = findIndex(feedPlan.plan, function(o){return o.feedStage == 99});
        const nextStageIndex = currentFeedStageIndex !== -1 ? getNextSequentialStageIndex(currentFeedStageIndex, feedPlan.plan, auxiliaryIndices) : -1;
        const prevStageIndex = currentFeedStageIndex !== -1 ? getPrevSequentialStageIndex(currentFeedStageIndex, feedPlan.plan, auxiliaryIndices) : -1;
    
    let qtyPrevista:any = undefined;
    let qtyReal:any = undefined;
    let qtyReserved:any = undefined;
    let qtyRegularization:any = undefined;
    let downDesv:any = undefined;
    let qtyConsumidaPercentage:any = undefined;
    let tmpStageData:IFeed|undefined = undefined;

    if(currentFeedStageIndex !== -1 && feedPlan.plan[currentFeedStageIndex] !== undefined && Array.isArray(feedPlan.plan[currentFeedStageIndex].feed) && feedPlan.plan[currentFeedStageIndex].feed.length > 0){
        qtyPrevista = feedPlan.plan[currentFeedStageIndex].feed[0].qtyEstimated;
        qtyReal = feedPlan.plan[currentFeedStageIndex].feed[0].qtyReal;
        qtyReserved = feedPlan.plan[currentFeedStageIndex].feed[0].qtyReserved;
        qtyRegularization = feedPlan.plan[currentFeedStageIndex].feed[0].qtyRegularization || 0;
        qtyConsumidaPercentage = ((qtyReal + qtyReserved - qtyRegularization)/qtyPrevista)*100;
        downDesv = 100 - feedPlan.plan[currentFeedStageIndex].feed[0].lowerAllowedDeviation;
    } else if(currentFeedStageIndex !== -1) {
        // Stage exists but has no feed articles (Dynamics can have empty stages)
        // Treat as 0% consumption with 0% deviation so products from adjacent stages can still appear
        qtyConsumidaPercentage = 0;
        downDesv = 0;
    }
    
    
        products.map((item:IProduct, index:number)=>{
            if(item.business == farm.business){
                if(downDesv !== undefined && qtyConsumidaPercentage !== undefined) {
                // Revisa los productos para el feedPlan actual
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && Array.isArray(feedPlan.plan[currentFeedStageIndex].feed) && findIndex(feedPlan.plan[currentFeedStageIndex].feed, function(o) { return o.itemId == item.itemId; }) !== -1){

                    tmpStageData = feedPlan.plan[currentFeedStageIndex].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    newProducts.push({
                        ...item,
                        allowItem:allowAddItem(item, farm, currentFeedStageIndex, feedPlan),
                        maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                        continues: feedPlan.continues,
                        feedStage: currentFeedStageIndex,
                        numEtapa: feedPlan.plan[currentFeedStageIndex].feedStage,
                        batchId: feedPlan.plan[currentFeedStageIndex].feed[findIndex(feedPlan.plan[currentFeedStageIndex].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                        remainingQty: remainingQty
                    });
                }
    
                // Si qtyConsumidaPercentage es igual o superior a downDesv abre la siguiente etapa
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && qtyConsumidaPercentage >= downDesv && nextStageIndex !== -1 && Array.isArray(feedPlan.plan[nextStageIndex].feed) && findIndex(feedPlan.plan[nextStageIndex].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                    tmpStageData = feedPlan.plan[nextStageIndex].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    newProducts.push({
                        ...item,
                        allowItem:allowAddItem(item, farm, nextStageIndex, feedPlan),
                        maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                        continues: feedPlan.continues,
                        feedStage: nextStageIndex,
                        numEtapa: feedPlan.plan[nextStageIndex].feedStage,
                        batchId: feedPlan.plan[nextStageIndex].feed[findIndex(feedPlan.plan[nextStageIndex].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                        remainingQty: remainingQty,
                        isNextStage: true
                    });
                }

                // Etapa anterior: se abre si tiene cantidad restante y no ha superado su propio upperAllowedDeviation
                if(feedPlan.plan[currentFeedStageIndex] !== undefined && prevStageIndex !== -1 && Array.isArray(feedPlan.plan[prevStageIndex].feed) && findIndex(feedPlan.plan[prevStageIndex].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                    tmpStageData = feedPlan.plan[prevStageIndex].feed[0];
                    const tmpQtyRegularization = tmpStageData.qtyRegularization || 0;
                    const remainingQty = (tmpStageData.qtyEstimated - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization));
                    const prevConsumption = ((tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization) / tmpStageData.qtyEstimated) * 100;
                    const prevUpperLimit = tmpStageData.upperAllowedDeviation + 100;

                    if(prevConsumption < prevUpperLimit){
                        newProducts.push({
                            ...item,
                            allowItem:allowAddItem(item, farm, prevStageIndex, feedPlan),
                            maxQty:((tmpStageData.qtyEstimated + (tmpStageData.qtyEstimated * (tmpStageData.upperAllowedDeviation/100))) - (tmpStageData.qtyReal + tmpStageData.qtyReserved - tmpQtyRegularization)),
                            continues: feedPlan.continues,
                            feedStage: prevStageIndex,
                            numEtapa: feedPlan.plan[prevStageIndex].feedStage,
                            batchId: feedPlan.plan[prevStageIndex].feed[findIndex(feedPlan.plan[prevStageIndex].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                            remainingQty: remainingQty,
                            isPreviousStage: true
                        });
                    }
                }
    
                    // En caso de haber etapa 99 añade el producto
                    if(etapa99Index !== -1 && Array.isArray(feedPlan.plan[etapa99Index].feed) && findIndex(feedPlan.plan[etapa99Index].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                        newProducts.push({
                            ...item,
                            allowItem:allowAddItem(item, farm, etapa99Index, feedPlan),
                            maxQty:farm.truckLoad,
                            continues: feedPlan.continues,
                            feedStage: (etapa99Index),
                            numEtapa: feedPlan.plan[etapa99Index].feedStage,
                            batchId: feedPlan.plan[etapa99Index].feed[findIndex(feedPlan.plan[etapa99Index].feed, function(o) { return o.itemId == item.itemId; })].batchId
                        });
                    }

                    // Auxiliary (out-of-sequence) stages: visible with their real status, but excluded from active-stage calculation
                    auxiliaryIndices.forEach((auxIdx:number) => {
                        if(Array.isArray(feedPlan.plan[auxIdx].feed) && findIndex(feedPlan.plan[auxIdx].feed, function(o) { return o.itemId == item.itemId; }) !== -1){
                            const auxFeed = feedPlan.plan[auxIdx].feed[0];
                            const auxQtyReg = auxFeed.qtyRegularization || 0;
                            newProducts.push({
                                ...item,
                                allowItem:allowAddItem(item, farm, auxIdx, feedPlan),
                                maxQty:((auxFeed.qtyEstimated + (auxFeed.qtyEstimated * (auxFeed.upperAllowedDeviation/100))) - (auxFeed.qtyReal + auxFeed.qtyReserved - auxQtyReg)),
                                continues: feedPlan.continues,
                                feedStage: auxIdx,
                                numEtapa: feedPlan.plan[auxIdx].feedStage,
                                batchId: feedPlan.plan[auxIdx].feed[findIndex(feedPlan.plan[auxIdx].feed, function(o) { return o.itemId == item.itemId; })].batchId,
                                remainingQty: (auxFeed.qtyEstimated - (auxFeed.qtyReal + auxFeed.qtyReserved - auxQtyReg))
                            });
                        }
                    });
                }
            }
        })
    })

    return sortBy(newProducts, [function(o) { return o.numEtapa; }]);
}

const getCurrentFeedPlanStage=(feedplan:IFeedPlan, auxiliaryIndices?:Set<number>)=>{
    if(feedplan.plan.length === 0){
        return -1;
    }

    const auxIndices = auxiliaryIndices ?? getAuxiliaryStageIndices(feedplan.plan);
    let firstNonEmptyIndex = -1;
    let lastWithConsumptionIndex = -1;

    for (var i = 0; i < feedplan.plan.length; i++) {
        if(auxIndices.has(i)) continue;

        const stage = feedplan.plan[i];
        const hasFeed = Array.isArray(stage.feed) && stage.feed.length > 0;

        if(hasFeed && firstNonEmptyIndex === -1){
            firstNonEmptyIndex = i;
        }

        if(hasFeed && stage.feedStage != 99){
            const feed = stage.feed[0];
            const qtyRegularization = feed.qtyRegularization || 0;
            const netConsumption = feed.qtyReal + feed.qtyReserved - qtyRegularization;

            if(netConsumption > 0){
                lastWithConsumptionIndex = i;
            }

            if(feed.qtyEstimated > 0){
                const consumptionPct = (netConsumption / feed.qtyEstimated) * 100;
                const downDesv = 100 - feed.lowerAllowedDeviation;
                if(consumptionPct < downDesv){
                    return i;
                }
            }
        }
    }

    if(lastWithConsumptionIndex !== -1) return lastWithConsumptionIndex;

    return firstNonEmptyIndex;
}

const verifyCarga = (box:number, quantity:number, truckLoad:number, forceDown?:boolean) =>{
    let quantityBox:number = Math.floor(truckLoad/box)
    let numberBox : number = forceDown?Math.floor(quantity/quantityBox):Math.round(quantity/quantityBox);
    let resultQuantity = quantity;
    if(numberBox==0){
        numberBox=1;
    }

    if(resultQuantity == ((box-numberBox)==0?truckLoad:(numberBox*quantityBox)) && resultQuantity <=truckLoad) {
        return [true, resultQuantity];
    }
    let modifiedQuantity = numberBox*quantityBox;

    if(modifiedQuantity <= truckLoad){
        return [false, ((box-numberBox)==0?truckLoad:(numberBox*quantityBox))];
    }

    return [false, truckLoad];
}

const allowAddQtySilo=(silo:ISilo, qty:number)=>{
    if(qty > silo.capacity){
        return false;
    }
    return true;
}

const currentLoad=(products:Array<IProduct>)=>{
    let totalQty = reduce(products, function(sum, n) {
        return sum + (n.quantity==undefined?0:n.quantity);
    }, 0);
    return totalQty;
}

const allowViewSilo=(silo:ISilo, product:IProduct, type:number)=>{
    switch(type){
        case 1: { // Verifica si el producto está dentro de los artículos permitidos para el silo
            const siloType:string = (silo as any).typeFeedSiloId ?? (silo as any).tipoPiensoSiloID ?? '';
            // Si no se ha configurado el tipo de pienso en el silo, permite asignar el producto en este
            if(!siloType || siloType.length === 0){
                return true;
            }

            const productGroups = Array.isArray(product.groupTypeSiloId) ? product.groupTypeSiloId : [];
            // Si el producto no trae grupos (p.ej. orígenes SQL), no restringimos por tipo de silo
            if(productGroups.length === 0){
                return true;
            }
            const findGroup = findIndex(productGroups, function(o){return o.typeFeedSiloId == siloType});

            if(findGroup > -1){
                return true;
            }
            return false;
        }
        default: // Por defecto no permite ver el silo
            return false;
    }
}

const getTotalQtyStage = (cart:Array<IProduct>, product:IProduct) => {
    let totalQty = reduce(cart, function(sum, n) {
        if(n.feedStage == product.feedStage){
            if(n.itemId !== product.itemId){
                return sum + (n.quantity==undefined?0:n.quantity);
            }
        }
        return sum;
    }, 0);
    return totalQty;
}

const controlProduct=(product:IProduct, cart:Array<IProduct>, farm:IFarm, quantity:number)=>{
    let qty:number = quantity;
    let result = 0;
    let count = 0;
    let maxLoop = 2;
    let doAgain = false;
    do{
        doAgain = false;

        if(!product.continues){ // Realiza el control en caso de no ser una granja del tipo Ciclo contínuo
            let accumStage = getTotalQtyStage(cart, product);

            if((accumStage + qty) > product.maxQty){ // Si la cantidad de producto supera la cantidad total de la etapa, devuelve el error y la cantidad siempre y cuando no sean granjas de madres
                result = 3;
                qty = product.maxQty-accumStage;
            }
        }

        let load = currentLoad(cart) - (product.isInCart && product.quantity?product.quantity:0);

        let freeSpace = farm.truckLoad - load;

        if((freeSpace - qty) < 0){ // Si la carga del camión es superada, devuelve el error y la carga que debería tener
            result = 2;
            qty = freeSpace;
        }
    
        if(product.notRoundBox == 0){ // Se redondea el cajón
            let carga:any = verifyCarga(6, qty, farm.truckLoad, count==0?false:true);
            
            if(!carga[0]){ // Ajusta cantidad cajón
                qty = carga[1];
                doAgain = true;
                if(result == 0){ // Solo dice que ha ajustado cajón cuando no ha habido otro ajuste
                    result = 1;
                }
            }
        }
        count++;
    }   while(doAgain && count <=maxLoop)

    if(doAgain){
        result = -1;
        qty = 0;
    }
    return [result, qty];
}

const controlSiloProduct=(silo:ISilo, product:IProduct, quantity:number)=>{
    let qty:number = quantity;
    let result:number = 0;
    if(!allowAddQtySilo(silo, qty)){ // Controla si la cantidad excede la capacidad del silo
        result = 1;
        qty = silo.capacity;
    }

    return([result, qty]);
    
}

// Letras válidas del bloque nacional (DGT desde sep-2000): sin vocales, Ñ ni Q
const MODERN_PLATE_LETTERS = 'BCDFGHJKLMNPRSTVWXYZ';

// Camión: sistema nacional 2000 (0000 + 3 consonantes) o sistemas provinciales
// 1900-2000 (1-2 letras de provincia + 1-6 dígitos + 0-2 letras de serie, con vocales)
const TRUCK_PLATE_REGEX = new RegExp(`^(?:[0-9]{4}[${MODERN_PLATE_LETTERS}]{3}|[A-Z]{1,2}[0-9]{1,6}[A-Z]{0,2})$`);

// Remolque: sistema nacional 2000 (R + 0000 + 3 consonantes) o provincial
// (1-2 letras de provincia + 1-6 dígitos + R final obligatoria), p.ej. MU06270R
const TRAILER_PLATE_REGEX = new RegExp(`^(?:R[0-9]{4}[${MODERN_PLATE_LETTERS}]{3}|[A-Z]{1,2}[0-9]{1,6}R)$`);

// Solo se eliminan separadores documentados (espacio, guion, punto). Cualquier otro
// carácter (puntuación, letras no ASCII como Ñ) se conserva para que el regex lo rechace.
const normalizeNumberPlate = (numberplate: string): string =>
    numberplate.trim().toUpperCase().replace(/[\s.-]/g, '');

const CheckNumberPlate = (type: number, numberplate: string): boolean => {
    const plate = normalizeNumberPlate(numberplate);
    switch(type){
        case 1: // Matrícula de camión
            return TRUCK_PLATE_REGEX.test(plate);
        case 2: // Matrícula de remolque
            return TRAILER_PLATE_REGEX.test(plate);
        default:
            return false;
    }
}

const isDynamicsFarm = (business?: string): boolean => {
    if (!business) return false;
    return ['pdx', 'tor', 'dlz'].includes(business.toLowerCase());
};

const initDeliveryQuantities = (products: Array<IProduct>): Array<IProduct> => {
    return products.map((i: IProduct) => ({
        ...i,
        quantityDelivered: !i.quantityDelivered ? i.quantity : i.quantityDelivered,
    }));
};

export { fetchAPI, searchFarms, GetFormattedDate,
    GetDate, searchProducts,
    getNextOrden, getQuantitySilo, getAcumuladoPienso,
    verifyDateTimeLimit, createArrayPedido,
    calculateQuantityItems, GetFormattedPedidoDate, addZeroesDecimals,
    /*getStatusDescriptionColor,*/searchPedidos, getProductsCurrentFeedPlanStage,
    getCurrentFeedPlanStage, verifyCarga, GetDatetimeFormat,
    addThousandSeparator, allowAddQtySilo, currentLoad, allowViewSilo,
    getTotalQtyStage, controlProduct, controlSiloProduct, CheckNumberPlate,
    isDynamicsFarm, getAuxiliaryStageIndices, initDeliveryQuantities
};